import { CountryInput } from '@commenda/kakashi';
import { Country } from '@prisma/client';
import { MoleculeCard } from '../helpers/MoleculeCard';
import { MoleculeCardTitle } from '../helpers/MoleculeCardTitle';

type EntityOperationalCountriesDropdownProps = {
  onSelectOperationalCountry: (country: Country[]) => void;
  selectedOperationalCountry: Country[] | null;
  disabled?: boolean;
  error?: string;
};

export function EntityOperationalCountriesDropdown({
  onSelectOperationalCountry,
  selectedOperationalCountry,
  disabled = false,
  error,
}: EntityOperationalCountriesDropdownProps) {
  return (
    <MoleculeCard>
      <MoleculeCardTitle title="Operational countries" />
      <CountryInput
        type="multiple"
        value={selectedOperationalCountry ?? []}
        onValueChange={(value) => {
          if (value) {
            onSelectOperationalCountry(value as Country[]);
          }
        }}
        placeholder="Select operational countries"
        disabled={disabled}
        error={error}
      />
    </MoleculeCard>
  );
}
